module.exports = __webpack_public_path__ + "media/img/corporate/company_profile_4-e09f672fc17de986e2d4f4a42797ea44.svg";